<template>
  <v-app>
    <div class="center">
      <h2 class="title">Image details</h2>
      <v-btn @click="getData()" icon><v-icon>mdi-refresh</v-icon></v-btn>
    </div>
    <v-row class="mx-auto" no-gutters style="flex:none !important;" >
      <!-- <v-col cols="0" sm="0" md="1"></v-col> -->
      <v-col col="12" sm="5">
      <v-card
        max-width="450"
        class="mx-auto my-2">
        <v-list three-line>
          <v-list-item-group
            multiple
          >
          <v-subheader><b>Paid Images</b></v-subheader>
          <template v-for="(item) in paid_images">
              <v-list-item :key="item.index">
                <!-- <v-list-item-avatar>
                <v-icon
                    color="#00BEFF">
                    mdi-checkbox-marked-circle
                </v-icon>
                </v-list-item-avatar> -->
                <v-list-item-content>
                    <v-list-item-title>{{item.MPGOrderNo}}</v-list-item-title>
                    <v-list-item-subtitle> {{item.deviceID}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{moment(item.CreateDate)}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon
                    color="#00BEFF">
                    mdi-checkbox-marked-circle
                </v-icon>
              </v-list-item>
          
          </template>
          </v-list-item-group>
        </v-list>
      </v-card>
      </v-col>
      <v-col col="0" sm="2"></v-col>
      <v-col cols="12" sm="5" >
      <v-card 
        max-width="450"
        class="mx-auto my-2">
        <v-list three-line>
          <v-list-item-group
            multiple
            v-model="unpaid"
          >
          <v-subheader><b>Not Paid Images</b></v-subheader>
          <template v-for="(item) in unpaid_images">
              <v-list-item :key="item.index">
                <template v-slot:default="{ active }">
                <v-list-item-content>
                    <v-list-item-title>{{item.MPGOrderNo}}</v-list-item-title>
                    <v-list-item-subtitle> {{item.deviceID}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{moment(item.CreateDate)}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon
                    v-if="active"
                    color="#00BEFF">
                    mdi-checkbox-marked-circle
                </v-icon>
                <v-icon
                    v-else
                    color="#00BEFF">
                    mdi-circle-outline
                </v-icon>
                </template>
              </v-list-item>
          </template>
          </v-list-item-group>
        </v-list>
      </v-card>
      </v-col>
      <!-- <v-col cols="0" sm="0" md="1"></v-col> -->
    </v-row>
    <div class="center">
      <v-btn @click="show_selected()" class="my-5 green" dark>Proceed</v-btn>
    </div>
    <v-dialog v-model="pay_dialog" max-width="450" class="white">
      <v-card justify-center
          max-width="450"
          class="mx-auto">
           <v-row align="end" justify="end" class="pa-5">
          <v-btn icon color="error" @click="pay_dialog = false">
            <v-icon >mdi-close</v-icon>
          </v-btn>
          </v-row>
          <v-list three-line>
            <v-list-item-group
              multiple
            >
            <v-subheader><b>Selected Images</b></v-subheader>
            <template v-for="(item) in selected">
                <v-list-item :key="item.index">
                  <v-list-item-content>
                      <v-list-item-title>{{item.MPGOrderNo}}</v-list-item-title>
                      <v-list-item-subtitle> {{item.deviceID}}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{moment(item.CreateDate)}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-icon
                      color="#00BEFF">
                      mdi-checkbox-marked-circle
                  </v-icon>
                </v-list-item>
            </template>
            </v-list-item-group>
          </v-list>
          <v-row justify="center" class="py-8">
            <v-btn color="green" @click="call_mpg_api" dark :loading="load_payment_info">Pay Now </v-btn>
          </v-row>
        </v-card>
    </v-dialog>
    <form action="https://ccore.NewebPay.com/MPG/mpg_gateway" method="POST" target="_blank" id="form_pay">
        <div style="display:none;">
        <input name="MerchantID" v-model="info_mpg.merchantID"><br>
        <input name="TradeInfo" v-model="info_mpg.tradeInfo"><br>
        <input name="TradeSha" v-model="info_mpg.tradeSha"><br>
        <input name="Version" v-model="info_mpg.version"><br>
        </div>
    </form>
    <v-snackbar v-model="select_error">
      Please select the image to pay.
    </v-snackbar>
  </v-app> 
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data(){
    return{
        deviceID:'HTC1234',
        allData:[],
        paid_images:[],
        unpaid_images:[],
        tabs:null,
        selected:[],
        unpaid:[],
        pay_dialog:false,
        select_error:false,
        info_mpg:{},
    }
  },
  async mounted(){
    let formData = new FormData()
    formData.append('DeviceID','HTC1234');
    let res = await axios.post('https://192.168.60.23:44340/api/GetOrderList',formData)
    this.allData = res.data;
    this.paid_images = this.allData.filter(item => item.Payed =='Y')
    this.unpaid_images = this.allData.filter(item => item.Payed =='N')
  }, 
  methods:{
    async getData(){
      let formData = new FormData()
      formData.append('DeviceID','HTC1234');
      let res = await axios.post('https://192.168.60.23:44340/api/GetOrderList',formData)
      this.data= res.data;
    },
    moment(date){
      return moment(date).format("lll")
    },
    show_selected(){
      //selected array index push that unpaid image to selected
      if(this.unpaid.length){
        for(let i = 0 ; i< this.unpaid.length; i++)
        {
          this.selected.push(this.unpaid_images[this.unpaid[i]])
        }
        this.load_payment_info = true
        //call api to get merchant ,tradesha,..
        //load that data to info_mpg
        this.load_payment_info = false

        this.pay_dialog = true
      }else{
        this.select_error = true
      }
    },
    call_mpg_api(){
      //call mpg from data from backend
    }
  }
}
</script>
<style scoped>
.center{
  text-align: center;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
  margin-bottom: 20px;
}
.title{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.v-list{
  max-height:580px;
  overflow-y:auto
}
</style>